import React, { useRef } from 'react'
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'
import Slider from "react-slick";
import PrevArrow from "~images/slider-prev-arrow.svg";
import { DescriptionCalls } from "~/components/pages/features/components/description-calls";

const Calls: React.FC = () => {
    const sliderRef = useRef(null)
    const images = [
        {
            img: `${process.env.PUBLIC_DIR}/images/features-page/calls/main-img.svg`,
        },
        {
            img: `${process.env.PUBLIC_DIR}/images/features-page/calls/conversations-img.svg`,
        },
        {
            img: `${process.env.PUBLIC_DIR}/images/features-page/calls/estimation-img.svg`,
        },
        {
            img: `${process.env.PUBLIC_DIR}/images/features-page/calls/main-img.svg`,
        }
    ]

    const descriptionCalls = [
        {
            icon: `${process.env.PUBLIC_DIR}/images/phone.svg`,
            title: 'Маршрутизация звонков',
            features: ['Голосовые приветствия', 'Постановка звонков в очередь', 'Звонки на группу', 'Перенаправление на ответственного менеджера',
            'Переадресация', <>Разные способы <br /> распределения звонков</>]
        },
        {
            icon: `${process.env.PUBLIC_DIR}/images/voicemail.svg`,
            title: 'Запись разговоров и хранение звонков',
            features: ['Ускоренная прослушка', 'Поиск и фильтрация', 'Графики нагрузки', 'Расчет средних значений',
            'Стерео и монозапись']
        },
        {
            icon: `${process.env.PUBLIC_DIR}/images/bar-chart.svg`,
            title: 'Анализ нагрузки',
            features: [<>Количество звонков <br /> по типам</>, <>Длительность <br /> разговоров</>]
        }
    ]

    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        useCSS: true,
        adaptiveHeight: false,
        appendDots: (dots: any) => (
            <Styled.Dots>
                <ul style={{ margin: "0px" }}> {dots} </ul>
            </Styled.Dots>
        ),
        customPaging: (i: number) => (
            <Styled.Dot />
        ),
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    dots: true
                }
            }
        ]
    };

    const next = () => {
        if (sliderRef) sliderRef.current.slickNext()
    }

    const prev = () => {
        if (sliderRef) sliderRef.current.slickPrev()
    }

    return (
        <Styled.Wrapper>
            <Styled.Title><StyledScreen.GreenText>Управление</StyledScreen.GreenText> звонками</Styled.Title>
            <Styled.Container>
                <Styled.Slider>
                    <Slider ref={sliderRef} { ...sliderSettings }>
                        {
                            images.map(image => (
                              <Styled.Slide>
                                  <img src={image.img} alt='onpbx-img' />
                              </Styled.Slide>
                            ))
                        }
                    </Slider>
                    <Styled.Prev onClick={prev}><PrevArrow /></Styled.Prev>
                    <Styled.Next onClick={next}><PrevArrow /></Styled.Next>
                </Styled.Slider>
            </Styled.Container>
            <Styled.DescriptionContainer>
                {descriptionCalls.map((item) => (
                  <DescriptionCalls key={item.title} icon={item.icon} title={item.title} text={item.features}/>
                ))}
            </Styled.DescriptionContainer>
        </Styled.Wrapper>
    )
}

export default Calls
